import React, { useState, useRef } from 'react';
import cn from 'classnames';
import style from './index.module.scss';
const play_btn = '/v2/images/pc-play.png';

interface IProps {
  videoSrc: string;
  src: string;
  title: string;
}

const PlayerMobile = ({ videoSrc, src, title }: IProps) => {
  const [isPlay, setIsPlay] = useState(false);
  const videoRef = useRef<HTMLVideoElement>(null);
  const play = (value: boolean) => {
    setIsPlay(true);
    if (value) {
      videoRef.current?.play();
    } else {
      videoRef.current?.pause();
    }
  };
  return (
    <div className={cn(style['player-m'], 'for-mobile')}>
      <div className={style.bg} style={{ backgroundImage: `url(${src})` }}>
        <img src={play_btn} alt="" onClick={() => play(true)} />
        <video ref={videoRef} controls style={{ display: isPlay ? 'block' : 'none' }} src={videoSrc}>
          您的浏览器不支持video
        </video>
      </div>
      <p className={style.title}>{title}</p>
    </div>
  );
};
export default PlayerMobile;
